import React from 'react';
import { FlameIcon } from 'lucide-react';
const SPOTS_LEFT = 12;
const TOTAL_SPOTS = 150;
const filled = Math.round((TOTAL_SPOTS - SPOTS_LEFT) / TOTAL_SPOTS * 100);
type ScarcitySpotsProps = {
  tone?: 'light' | 'dark';
};
export function ScarcitySpots({
  tone = 'light'
}: ScarcitySpotsProps) {
  const isDark = tone === 'dark';
  return <div className={`w-full rounded-2xl border p-4 ${isDark ? 'border-white/15 bg-white/5' : 'border-navy/10 bg-white shadow-sm'}`} data-id="element-235" data-mp="e9fa46j6icax">
      <div className="flex items-start gap-2" data-id="element-236" data-mp="16wjhgi5qv2pv">
        <FlameIcon className="mt-0.5 h-4 w-4 shrink-0 text-[#E2574C]" aria-hidden="true" data-id="element-237" data-mp="sy1xmviymad8" />
        <p className={`text-[13px] font-bold leading-snug ${isDark ? 'text-white' : 'text-navy'}`} data-id="element-238" data-mp="xwmz0y9y7039">
          Only {SPOTS_LEFT} spots left at the promotional price of $27
        </p>
      </div>

      <div className={`mt-3 h-3 w-full overflow-hidden rounded-full ${isDark ? 'bg-white/15' : 'bg-navy/10'}`} role="img" aria-label={`${filled}% of promotional spots already claimed`} data-id="element-239" data-mp="3ioylfaxjl1e6">
        <div className="h-full rounded-full bg-[#E2574C]" style={{
        width: `${filled}%`
      }} data-id="element-240" data-mp="1nrgxkj4j5f3r" />
      </div>

      <p className={`mt-2 text-[11px] font-semibold uppercase tracking-wide ${isDark ? 'text-white/60' : 'text-navy2/70'}`} data-id="element-241" data-mp="1is47lpid3rwy">
        {TOTAL_SPOTS - SPOTS_LEFT} of {TOTAL_SPOTS} launch spots claimed
      </p>
    </div>;
}